import type { ReactNode } from "react";
interface Props { topBar: ReactNode; children: ReactNode; statusBar?: ReactNode; }
export function AppShell({ topBar, children, statusBar }: Props) {
  return (
    <div className="grid h-full grid-rows-[auto_1fr_auto] bg-[var(--color-surface)]">
      <header className="border-b border-[var(--color-border)] bg-[var(--color-surface-container-low)]">{topBar}</header>
      <main className="min-h-0 overflow-hidden">{children}</main>
      {statusBar ? (
        <footer className="border-t border-[var(--color-border)] bg-[var(--color-surface-container-low)] px-3 py-1 text-[11px] text-[var(--color-on-surface-variant)]">
          {statusBar}
        </footer>
      ) : null}
    </div>
  );
}
